(function () {
  'use strict';

  angular.module('settings.customization', ['ui.router', 'ngResource']);
})();
